<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import moment from 'moment';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Roles',
		meta: [
			{
				name: 'Roles',
			},
		],
	},
	components: {},
	props: {
		userTypeId: Number,
	},
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			userId: '',
			assignedRoles: {},
			isLoading: false,
			noRecord: false,
		};
	},
	filters: {
		moment: function (date) {
			if (date === null) {
				return '';
			}
			return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
		},
	},
	mounted() {
		this.userId = this.$route.params.id;
		this.getAssignedRoles();
	},
	methods: {
		getAssignedRoles() {
			this.isLoading = true;
			this.noRecord = false;
			axios
				.get('admin/schedule/users/assignment/role/' + this.userId)
				.then((res) => {
					this.assignedRoles = res.data.response;
					this.isLoading = false;
					if (!this.assignedRoles.length) {
						this.noRecord = true;
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 404) {
							this.noRecord = true;
							this.isLoading = false;
						}
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		...authFackMethods,

		changeStatus(id, status) {
			var token = localStorage.getItem('token');
			var config = {
				headers: {
					Authorization: 'Bearer ' + token,
					Accept: 'application/json',
				},
			};
			Swal.fire({
				title: 'Are you sure?',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#34c38f',
				cancelButtonColor: '#f46a6a',
				confirmButtonText: 'Yes, Do it!',
			}).then((result) => {
				if (result.value) {
					if (token) {
						axios
							.get('admin/assignment/update/status/' + id + '?status=' + status + '&user_id=' + this.userId, config)
							.then((res) => {
								if (res.status == '200') {
									Swal.fire({
										title: 'Approved!',
										text: 'Status has been Changed!',
										icon: 'success',
										width: 350,
										showConfirmButton: false,
										timer: 1500,
									});
									this.getAssignedRoles();
								}
							})
							.catch((err) => {
								if (err.response) {
									console.log(err.response.data.error.message);
								}
							});
					}
				}
			});
		},
	},
};
</script>

<template>
	<div>
		<div class="row mt-3">
			<div class="col-md-12 px-0 cards-cont">
				<div v-if="noRecord">
					<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
				</div>

				<div class="text-center" v-if="isLoading">
					<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
				</div>

				<div v-if="userTypeId == 3">
					<b-card class="border border-2 shadow-none" v-for="(role, index) in assignedRoles" :key="index">
						<h5 slot="header" class="mb-0">
							{{ role.user_type }}
							<p class="mb-0 float-end icons-wrap">
								<span v-if="role.status == 'active'" class="text-success">Active</span>
								<span v-else-if="role.status == 'completed'" class="text-primary">Completed</span>
								<span v-else-if="role.status == 'inactive'" class="text-danger">InActive</span>
								<span v-else class="text-warning">Actions</span>
								<b-dropdown toggle-class="text-muted font-size-16 p-0" variant="white" right class="ms-auto" menu-class="dropdown-menu-end">
									<template #button-content>
										<i class="bx bx-caret-down"></i>
									</template>
									<b-dropdown-item @click="changeStatus(role.id, 'active')" href="#">Active</b-dropdown-item>
									<b-dropdown-item @click="changeStatus(role.id, 'completed')" href="#">Completed</b-dropdown-item>
									<b-dropdown-item @click="changeStatus(role.id, 'inactive')" href="#">InActive</b-dropdown-item>
								</b-dropdown>
							</p>
						</h5>
						<b-card-text>
							<form action="#">
								<div class="d-flex date-info">
									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">Start Date:</label>
										<label class="mb-0">{{ new Date(role.started_at).toLocaleString().split(',')[0] }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
									</p>

									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">End Date:</label>
										<label class="mb-0">{{ new Date(role.ended_at).toLocaleString().split(',')[0] }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
									</p>

									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">Approved By:</label>
										<label class="mb-0">{{ role.approver ? `${role.approver.first_name} ${role.approver.last_name}` : 'N/A' }}</label>
									</p>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Location</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Location" name="tag" :value="role.location ? role.location : 'N/A'" />
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Mentor Building Assignment</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Location" name="tag" :value="role.building ? role.building : 'N/A'" />
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Assigned To</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Assignee" name="tag" :value="role.username ? role.username : 'N/A'" />
									</div>
								</div>
							</form>
						</b-card-text>
					</b-card>
				</div>

				<!-- VOLUNTEER -->
				<div v-else>
					<b-card class="border border-2 shadow-none" v-for="(role, index) in assignedRoles" :key="index">
						<h5 slot="header" class="mb-0">
							{{ role.user_type }}

							<p class="mb-0 float-end icons-wrap">
								<span v-if="role.status == 'active'" class="text-success">Active</span>
								<span v-else-if="role.status == 'completed'" class="text-primary">Completed</span>
								<span v-else-if="role.status == 'inactive'" class="text-danger">InActive</span>
								<span v-else-if="role.status == 'awaiting_approval'" class="text-warning">Awaiting Approval</span>
								<span v-else class="text-warning">Actions</span>
								<b-dropdown toggle-class="text-muted font-size-16 p-0" variant="white" right class="ms-auto" menu-class="dropdown-menu-end">
									<template #button-content v-if="role.status != 'awaiting_approval'">
										<i class="bx bx-caret-down"></i>
									</template>
									<b-dropdown-item @click="changeStatus(role.assignment_id, 'active')" href="#">Active</b-dropdown-item>
									<b-dropdown-item @click="changeStatus(role.assignment_id, 'completed')" href="#">Completed</b-dropdown-item>
									<b-dropdown-item @click="changeStatus(role.assignment_id, 'inactive')" href="#">InActive</b-dropdown-item>
								</b-dropdown>
							</p>
						</h5>
						<b-card-text>
							<form action="#">
								<div class="d-flex date-info">
									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">Start Date:</label>
										<label class="mb-0">{{ role.started_at | moment }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
									</p>

									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">End Date:</label>
										<label class="mb-0">{{ role.ended_at | moment }} <i class="ms-1 bx bx-calendar font-size-20"></i></label>
									</p>

									<p class="mb-0">
										<label class="mb-0 me-3 fw-bold">Approved By:</label>
										<label class="mb-0">{{ role.approver ? role.approver : 'N/A' }}</label>
									</p>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Location</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Location" name="tag" :value="role.location ? role.location : 'N/A'" />
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Building</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Role" name="tag" :value="role.building ? role.building : 'N/A'" />
									</div>
								</div>

								<div class="mb-3 row">
									<div class="col-3">
										<label>Role</label>
									</div>
									<div class="col-9">
										<input type="text" class="form-control" placeholder="Enter Role" name="tag" :value="role.role ? role.role : 'N/A'" />
									</div>
								</div>
							</form>
						</b-card-text>
					</b-card>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.date-info {
	margin-bottom: 3rem;
}
.date-info p {
	margin-left: 1rem;
	align-items: baseline;
	display: flex;
	align-items: center;
}
.date-info p:first-child {
	margin-left: 0px;
}
.date-info p label i {
	position: relative;
	top: 0.2rem;
}
</style>
